<template>
	<div class="w-full">
		<div class="flex flex-wrap w-full font-bold bg-gray-300 rounded text-gray-800 shadow-md mb-6">
			<div class="flex-1 text-left py-3 px-4 w-full md:w-auto md:text-right">
				<button class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0 outline-none" v-on:click="modal = true">
					Create Announcement
				</button>
			</div>
		</div>

        <div class="w-full text-center" v-if="loading">
            <div class="py-5" colspan="4">
                <h1 class="text-xl"><i class="fa fa-circle-notch fa-spin"></i></h1>
            </div>
        </div>

        <!-- chasers -->
        <div class="flex flex-wrap">
            <div class="w-full bg-white rounded-lg shadow p-6 mb-6" v-for="announcement in announcements">
                <h3 class="text-xl font-semibold pb-3 border-b-2 border-grey-lighter mb-4">
                    {{ announcement.title }}
                </h3>
                <div class="w-full">
                    <p>{{announcement.message}}</p>
                </div>
            </div>
        </div>

        <!-- chasers -->
        <div class="flex flex-wrap">
            <div class="w-full bg-white rounded-lg shadow p-6 mb-6 py-10 text-center" v-if="announcements.length == 0 && loading == false">
                <h2>No announcements found! Create one to get rid of this message.</h2>
            </div>
        </div>

        <Modal :open="modal" @close="modal = false">
            <div class="max-w-3lg w-full bg-white rounded-lg shadow-2xl px-6 py-6">
                <!-- header -->
                <h2 class="font-semibold text-gray-900 text-2xl leading-tight border-b-2 border-gray-200 pb-4">Create an announcement</h2>

                <!-- body -->
                <div class="mt-4 md:flex md:items-center mb-6">
                    <div class="md:w-1/3">
                        <label class="block text-grey-darkest font-bold md:text-left mb-1 md:mb-0 pr-4" for="inline-full-name">
                            Title
                        </label>
                    </div>
                    <div class="md:w-2/3">
                        <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="id" type="text" v-model="newAnnouncement.title">
                    </div>
                </div>

                <div class="md:flex md:items-center mb-6">
                    <div class="md:w-1/3">
                        <label class="block text-grey-darkest font-bold md:text-left mb-1 md:mb-0 pr-4" for="inline-full-name">
                            Message
                        </label>
                    </div>
                    <div class="md:w-2/3">
                        <textarea class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="pass" type="password" rows="5" v-model="newAnnouncement.message">
                        </textarea>
                    </div>
                </div>

                <div class="md:flex md:items-center mb-6">
                    <div class="md:w-1/3">
                        <label class="block text-grey-darkest font-bold md:text-left mb-1 md:mb-0 pr-4" for="inline-full-name">
                            Category
                        </label>
                    </div>
                    <div class="md:w-2/3">
                        <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="id" type="text"  v-model="newAnnouncement.category">
                    </div>
                </div>
                
                <!-- footer -->
                <div class="mt-10 clearfix">
                    <!-- @click="addAnnouncement()" -->
                    <button @click="modal = false" class="px-4 py-2 text-gray-800 font-semibold bg-white hover:bg-gray-100 border rounded focus:outline-none focus:shadow-outline float-left">
                        Cancel
                    </button>
                    <button type="button" @click="addAnnouncement()" class="px-4 py-2 text-white font-semibold bg-blue-700 hover:bg-blue-800 border border-transparent rounded focus:outline-none focus:shadow-outline float-right">
                        Create announcement
                    </button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>

	import * as Config from '@/config'
	import { mapState, mapGetters } from 'vuex';
	import { EventBus } from '@/utils/events';

	import CustomTable from '@/components/general/CustomTable'
    import Card from '@/components/partials/Card'
    import Modal from '@/components/Modal'

	export default {
		name: 'Announcements',
		data () {
			return {
				announcements: [],
                loading: true,
                newAnnouncement: {
                    title: null,
                    message: null,
                    category: null,
                },
                modal: false,
			}
		},
		components: {
			CustomTable,
            Card,
            Modal
		},
		mounted() {
			this.getAnnouncements();
		},
		methods: {
			...mapGetters([
                'getAuthorizationHeader',
			]),
	
			getAnnouncements() {
                this.$http.get(Config.apiPath + "/api/v2/admin/announcements", this.getAuthorizationHeader()).then((response) => {
					this.$set(this, 'announcements', response.data)
                    this.$set(this, 'loading', false)
                });
            },
            addAnnouncement() {
                var _this = this
                this.$http.post(Config.apiPath + "/api/v2/admin/announcements", this.newAnnouncement, this.getAuthorizationHeader()).then((response) => {
                    _this.$swal(
                        'Sent!',
                        'Your announcement has been sent!',
                        'success'
                    )
                    _this.modal = false
                    _this.getAnnouncements()
                });
            },
		},
		filters: {
			timeAgo: function(date) {
                return moment.utc(date).fromNow();
            },
            displayLocalDateTime: function(date) {
                return moment.utc(date).local().format('MMMM Do YYYY, h:mm a');
            },
		}
       
	}
</script>